import _ from 'lodash';

import messages from '../LinkBankAccount.messages';
import { fieldValues } from './linkBankAccountFormValidationHandler';

// eslint-disable-next-line import/no-default-export
export default (values: fieldValues) => {
    let errors = {};

    if (!values.sortCode || values.sortCode.length !== 8) {
        errors = _.setWith(errors, 'sortCode', messages.requiredField);
    }

    if (!values.accountNumber || values.accountNumber.length !== 8) {
        errors = _.setWith(errors, 'accountNumber', messages.requiredField);
    }

    return errors;
};
